import { render, staticRenderFns } from "./entryRegisterLite.vue?vue&type=template&id=e6f85e0e&"
import script from "./entryRegisterLite.vue?vue&type=script&lang=js&"
export * from "./entryRegisterLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports